import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import * as styles from './TrendingListPanel.css';
import SelectedList from '../SelectedList/SelectedList';
import CreateListDropDown from '../CreateListDropDown/CreateListDropDown';

const cx = classNames.bind(styles);

class TrendingListPanel extends Component {
    static propTypes = {
        showTopMessage: PropTypes.func.isRequired,
        openSlider: PropTypes.func.isRequired,
        closeParentDialog: PropTypes.func.isRequired,
    };

    constructor() {
        super();
        this.state = {
            openCreateListDropdown: false,
        };
    }

    openCreateListDropdown = (e) => {
        e?.stopPropagation();
        const openDropDown = this.state.openCreateListDropdown;
        this.setState({
            openCreateListDropdown: !openDropDown,
        });
    };

    showTopMessage = (type, message, movedTo = '', movedId = '') => {
        this.props.closeParentDialog();
        this.props.showTopMessage(type, message, movedTo, movedId);
    };

    render() {
        const { openSlider } = this.props;
        const { openCreateListDropdown } = this.state;
        return (
            <div className={cx('trendingListPanel')}>
                <div className={cx('dropDownBlock')}>
                    <div className={cx('dropDown')}>
                        <SelectedList
                            listName="Trending List"
                            clickHandler={this.openCreateListDropdown}
                        >
                            {openCreateListDropdown && (
                                <CreateListDropDown
                                    openSlider={openSlider}
                                    clickHandler={this.openCreateListDropdown}
                                    showTopLevelMessage={this.showTopMessage}
                                />
                            )}
                        </SelectedList>
                    </div>
                </div>
            </div>
        );
    }
}

export default TrendingListPanel;
